/*
 * Product Variant Select Listener - trigger alternative products
 *
 **/
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

custom.variantDropdown = (() => {
  const singleClassName = 'js-single-variant';
  const selectorClassName = 'js-variant-dropdown';
  const noDropdownClassName = 'js-variant-dropdown--no-dropdown';
  const initClassName = 'js-variant-dropdown--initialized';
  const oosClassName = 'js-variant-dropdown--oos';
  const rugPadDriverClassName = 'js-rug-pad-driver';
  // Configuration
  const defaultPlaceholder = 'Select an Option';
  const jsLoadingOptionId = '.select2-disabled.js-loading-option';
  const jsLoadingOptionIdPillow =
    '.select2-disabled.js-is-pillow.js-loading-option';

  const loadingId = 'Loading...';
  const extraOptionId = 'hidden value';

  let isScrolling = false;

  String.prototype.replaceAll = function (search, replacement) {
    var target = this;
    return target.replace(new RegExp(search, 'g'), replacement);
  };

  function parsePriceByVariantId(data = {}, id = '') {
    const variant = JSON.parse(data).variants.filter(
      (variant) => variant.id == id,
    );
    return variant && variant[0] && variant[0].price
      ? custom.utils.formatPricing(variant[0].price)
      : custom.utils.formatPricing(999999);
  }

  function getVariantTemplateObj(
    state = null,
    isSelectedState = false,
    notAuth = false,
  ) {
    if (!state || !state.element) return;
    const oos = state.element.dataset.soldOut == 'true';
    let startTitle = state.element.text;
    if (state.element.text.indexOf('$') >= 0 && $(state.element).data('size')) {
      startTitle = $(state.element).data('size');
    }
    let title = oos ? startTitle.replace(' / Sold out', '') : startTitle;
    const inventoryQty = state.element.dataset.inventory;
    const lowInventory =
      oos != 'true' ? (inventoryQty <= 5 ? true : false) : false;
    const variant_id = state.element.dataset.variant_id;
    const variant_price =
      state.element.dataset.price && !notAuth && variant_id
        ? custom.utils.getVariantPriceById(variant_id)
        : null;
    const productType = state.element.dataset.productType;
    const map = state.element.dataset.map;
    const $map =
      map && !notAuth ? `<span class="select2-results__map">${map}</span>` : '';

    let $stock;
    if (oos) {
      $stock = `<span class="select2-results__stock ${oosClassName}">${state.element.dataset.restockDate}</span>`;
    } else if (
      isSelectedState &&
      (state.text.includes('Select a Size & View Inventory') ||
        state.text.includes('Select a Size & Fill'))
    ) {
      // hide stock when at default state
      $stock = '';
    } else if (lowInventory == true) {
      $stock = `<span class="select2-results__stock">Only ${inventoryQty} Left</span>`;
    } else {
      $stock = `<span class="select2-results__stock">In Stock</span>`;
    }
    let $price = variant_price
      ? `<span class="select2-results__price">${slate.Currency.formatMoney(
          variant_price,
          '${{ amount_no_decimals }}',
        )}</span>`
      : isSelectedState
        ? ''
        : '<span class="select2-results__price select2-results__price--unauth">Sign in For Pricing</span>';
    if (
      !isSelectedState &&
      state.element.dataset.price &&
      state.element.dataset.price === 'Contact For Pricing'
    )
      $price =
        '<span class="select2-results__price select2-results__price--unauth">Contact For Pricing</span>';

    if (productType) {
      title =
        productType == 'PILLOWS'
          ? title.replace(' PILLOW', '').replace('ROUND', 'R')
          : title.replaceAll('-', '').replace('X', 'x');
    }
    return {
      title,
      $price,
      $stock,
      variant_price,
      $map,
    };
  }

  function optionTemplate(isSelectedState = false, notAuth = false) {
    return function templateString(state) {
      if (!state.id || !state.element) {
        return $(
          '<span class="select2-results__option-row"><span class="select2-results__title select2-results__title--select truncate">Select a Size & View Inventory</span></span>',
        );
      }
      if (state.loading) return state.text;
      if (state.id == loadingId || state.id == extraOptionId) {
        $(`li[id*='${loadingId}']`).remove();
        return;
      }
      const variant = getVariantTemplateObj(state, isSelectedState, notAuth);
      return $(
        `<span class="select2-results__option-row"><span class="flex flex-col justify-center gap-1"><span class="select2-results__title">${variant.title}</span>${variant.$stock}</span><span class="flex flex-col justify-center gap-1">${variant.$price}${variant.$map}</span></span>`,
      );
    };
  }

  function customizeSingle(index = 0, selector = null) {
    if ($(selector).hasClass(initClassName)) return;
    if ($(selector).data('sold-out')) {
      custom.restockDate
        .getETA($(selector).data('variant-sku'))
        .done((data) => {
          const restockDate = custom.restockDate.getFirstRestockDate(data);
          if (restockDate && $(selector).find('.js-restock-date').length)
            $(selector).find('.js-restock-date').text(restockDate);
        });
    }
  }
  function addGtmSelectChangeListener(selector = null) {
    if (!selector) return;
    const $select = $(selector);
    if (
      $select.data('gtm-track-select-change') === true &&
      !$(selector).hasClass('gtm-variant-select-initialized')
    ) {
      $(selector).addClass('gtm-variant-select-initialized');
      $(selector).on('change', function () {
        let $selectorParentForm = $(selector).closest(
          '.js-add-single-to-cart-form',
        );
        if (
          $selectorParentForm.length > 0 &&
          $selectorParentForm.data('send-select-item')
        ) {
          $selectorParentForm.attr('data-send-select-item', 'false');
        }
        custom.gtmSelectItem.sendGTMSelectItemEvent($select, true);
      });
    }
  }

  function customizeSelect(index = 0, selector = null) {
    if ($(selector).hasClass(initClassName)) return;
    if ($(selector).data('gtm-track-select-change')) {
      addGtmSelectChangeListener(selector);
    }
    const $variants = $(selector).hasClass(noDropdownClassName)
      ? $(selector).find('option')
      : $(selector).children('option');
    const placeholder = $(selector).data('placeholder') || defaultPlaceholder;
    let promises = {};
    const notAuth =
      $(selector).data('authorized') &&
      $(selector).data('authorized') === 'unauthorized';
    const notLoggedIn =
      $(selector).data('customer') &&
      $(selector).data('customer') === 'noncustomer';

    $variants.each((index, variant) => {
      // If not no PDP, fetch all variants custom prices
      if (
        $(selector).data('customer') &&
        $(selector).data('customer') === 'noncustomer'
      ) {
        variant.setAttribute('data-price', ' ');
        variant.setAttribute('data-unauth', 'true');
      } else if (
        $(selector).data('authorized') &&
        $(selector).data('authorized') === 'unauthorized'
      ) {
        variant.setAttribute('data-price', 'Contact For Pricing');
        variant.setAttribute('data-unauth', 'true');
      } else {
        if ($(variant).data('price') && $(variant).data('price') == 'N/A') {
          const handle = $(selector).data('product-handle');
          const variantID = $(selector).attr('value');
        }
      }
      // If Sold Out, fetch all Restock Dates
      if ($(variant).data('sold-out')) {
        const eta = custom.restockDate.getETA($(variant).data('variant-sku'));
        variant.setAttribute('data-restock-date', 'Loading...');
        //TODO: confirm it's not actually necessary to set ETA promises with other promises.
        promises = {
          ...promises,
          [$(variant).data('variant-sku')]: eta,
        };
        eta.done((data) => {
          if (data) {
            const date = custom.restockDate.getFirstRestockDate(data);
            variant.setAttribute('data-restock-date', date);
            const sku = $(variant).data('variant-sku');
            if ($('.js-restock-date-inventory').length > 0) {
              $(`.js-restock-date-inventory[data-sku="${sku}"]`).text(date);
            }
            custom.FormNumbers.init();
          }
        });
      }
    });

    // Converts Promises Object to Array
    const hidePrices = notAuth || notLoggedIn;
    const promisesArr = Object.keys(promises).map((cur, index) => {
      return promises[cur];
    });
    $.when.apply($, promisesArr).done((data) => {
      // single variant
      if ($(selector).hasClass(noDropdownClassName)) {
        const parentID = $(selector).data('parent-id')
          ? $(selector).data('parent-id')
          : '';
        const variant = getVariantTemplateObj(
          { element: $variants[0] },
          false,
          hidePrices,
        );
        const variant_id = $(selector).data('variant_id');
        let displayPrice = !variant.variant_price
          ? custom.utils.getVariantPriceById(variant_id)
          : variant.variant_price;
        displayPrice = slate.Currency.formatMoney(
          displayPrice,
          '${{ amount_no_decimals }}',
        );
        const form = $(selector).closest('form');
        if (displayPrice || notAuth) {
          let priceSpan = notLoggedIn
            ? '<span class="select2-results__price select2-results__price--unauth">Sign in For Pricing</span>'
            : `<span class="select2-results__price money" data-product-id="${parentID}">${displayPrice}</span>`;
          if (notAuth && !notLoggedIn) {
            priceSpan =
              '<span class="select2-results__price select2-results__price--unauth">Contact For Pricing</span>';
          } else {
            if (priceSpan) {
              addToCartPrice(displayPrice, form);
            }
          }
          $(selector)
            .find('.select2-selection__rendered')
            .html(
              `<span class="select2-results__option-row"><span class="flex flex-col justify-center gap-1"><span class="select2-results__title truncate">${variant.title}</span>${variant.$stock}</span><span class="flex flex-col justify-center gap-1">${priceSpan}${variant.$map}</span></span>`,
            );
        } else {
          $(selector)
            .find('.select2-selection__rendered')
            .html(
              `<span class="select2-results__option-row"><span class="flex flex-col justify-center gap-1"><span class="select2-results__title truncate">${variant.title}</span>${variant.$stock}</span></span>`,
            );
          setTimeout(function () {
            displayPrice = custom.utils.getVariantPriceById(variant_id);
            displayPrice = slate.Currency.formatMoney(
              displayPrice,
              '${{ amount_no_decimals }}',
            );
            let priceSpan =
              notAuth || notLoggedIn
                ? '<span class="select2-results__price select2-results__price--unauth">Sign in For Pricing</span>'
                : `<span class="select2-results__price money" data-product-id="${parentID}">${displayPrice}</span>`;
            $(selector)
              .find('.select2-selection__rendered')
              .html(
                `<span class="select2-results__option-row"><span class="flex flex-col justify-center gap-1"><span class="select2-results__title truncate">${variant.title}</span>${variant.$stock}</span><span class="flex flex-col justify-center gap-1">${priceSpan}${variant.$map}</span></span>`,
              );
            if (priceSpan) {
              addToCartPrice(displayPrice, form);
            }
          }, 1000);
        }
        return $(selector).addClass(initClassName);
      }
    });
    if ($(selector).hasClass(noDropdownClassName)) return;

    if ($(`${jsLoadingOptionId}`).length)
      $(`${jsLoadingOptionId}`).html('Select a Size & View Inventory');

    if ($(`${jsLoadingOptionIdPillow}`).length)
      $(`${jsLoadingOptionIdPillow}`).html('Select a Size & Fill');

    // Initialize Select2
    const templateResult = optionTemplate(false, hidePrices);
    const templateSelection = optionTemplate(true, hidePrices);

    const $selectElement = $(selector)
      .select2({
        width: 'style',
        minimumResultsForSearch: Infinity,
        templateResult,
        templateSelection,
        placeholder: placeholder,
        sorter: function (variants) {
          return custom.algoliaUtils.variantSorter(variants);
        },
      })
      .maximizeSelect2Height({ cushion: 50 });
    $selectElement
      .on('select2:open', function (e) {
        $('body > .select2-container--default').addClass('opened');
        if ($(window).width() < 768) {
          disableBodyScroll(
            document.querySelector(
              'body>.select2-container--default .select2-dropdown',
            ),
            {
              allowTouchMove: (el) => {
                while (el && el !== document.body) {
                  if (el.getAttribute('body-scroll-lock-ignore') !== null) {
                    return true;
                  }

                  el = el.parentElement;
                }
              },
            },
          ); // Lock body Element
          //show overlay
          $('.js-modal-overlay').show();
        }
      })
      .on('select2:closing', function (e) {
        $('body > .select2-container--default').removeClass('opened');
        if ($(window).width() < 768) {
          clearAllBodyScrollLocks();
          //hide overlay
          $('.js-modal-overlay').hide();
        }
      })
      .on('select2:select', function (e) {
        calculatePrice(e);
      });
    $(selector).addClass(initClassName);
  }

  function calculatePrice(e) {
    //if a variant is selected, grab its price and append to add to cart form
    const price =
      $(e.currentTarget)
        .closest('form')
        .find('.select2-selection__rendered .select2-results__price')
        .text()
        .indexOf('$') >= 0
        ? $(e.currentTarget)
            .closest('form')
            .find('.select2-selection__rendered .select2-results__price')
            .text()
        : '';
    if (price) {
      let qty = $(e.currentTarget)
        .closest('form')
        .find('select[name="quantity"]')
        .val();
      let subtotal =
        parseFloat(price.replace('$', '').split(',').join('')) * Number(qty);
      //see if not in quick panel and a rug pad has been selected or not
      let rugpadPrice =
        $(`.${rugPadDriverClassName}`)
          .find('.select2-selection__rendered .select2-results__price')
          .text()
          .indexOf('$') >= 0
          ? $(`.${rugPadDriverClassName}`)
              .find('.select2-selection__rendered .select2-results__price')
              .text()
          : '';
      if (
        $(e.currentTarget).closest('form').data('event') !==
          'submit-quick-view' &&
        !$('.js-rug-pad-driver').hasClass('hidden') &&
        rugpadPrice
      ) {
        subtotal +=
          parseFloat(rugpadPrice.replace('$', '').split(',').join('')) *
          Number(qty);
      }
      let formattedprice = slate.Currency.formatMoney(
        subtotal.toFixed(2),
        '${{ amount_no_decimals }}',
      );
      addToCartPrice(formattedprice, $(e.currentTarget).closest('form'));
    }
  }

  function addToCartPrice(price, $form) {
    $form
      .find('button[type="submit"][data-label="Add to Cart"]')
      .html(
        `<div class="flex spacer-0--gap-x justify-center">Add to cart <span class="content-disabled">|</span> ${price}</span>`,
      );
  }

  function stripStrFromSelectRendered(str) {
    const $el = $('.select2-selection__rendered');

    if ($el.text().indexOf(str) !== -1) {
      $el.text($el.text().replace(str, ''));
    }
  }

  function onChangeHandler(event = {}) {
    const $submitBtn = $(event.currentTarget)
      .closest('form')
      .find("[type='submit']");
    return $(event.currentTarget).val()
      ? $submitBtn.prop('disabled', false)
      : $submitBtn.prop('disabled', true);
  }

  const init = () => {
    if ($(`.${selectorClassName}`).length) {
      $(`.${selectorClassName}`).on('change', (e) => {
        onChangeHandler(e);
      });
      $(`.${selectorClassName}`).on('select2:closing', (e) => {
        stripStrFromSelectRendered(' / Sold out');
      });
      $(`.${selectorClassName}`).each(customizeSelect);

      // find quantity selector
      $(`.${selectorClassName}`)
        .closest('form')
        .find('select[name="quantity"]')
        .on('change', (e) => {
          calculatePrice(e);
        });
    }
    if ($(`.${singleClassName}`).length)
      $(`.${singleClassName}`).each(customizeSingle);

    // if(!mobileAndTablet && $(`.${selectorClassName}`).length) $(`.${selectorClassName}`).each(customizeSelect);
    // if(mobileAndTablet && $(`.${selectorClassName}`).length) $(`.${selectorClassName}`).each(setPlaceholder);
  };

  return {
    init,
  };
})();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/variant-dropdown.js